<template>
  <el-dialog
    :title="$t('editAttrValue.editAttributeValue')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="editAttrValueInfo" :rules="rules" ref="editAttrValueForm">
      <el-form-item 
        :label="$t('editAttrValue.value')" 
        prop="value"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="editAttrValueInfo.value"
          :placeholder="$t('editAttrValue.requiredValue')"
        ></el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('editAttrValue.valueName')" 
        prop="valueName"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="editAttrValueInfo.valueName"
          :placeholder="$t('editAttrValue.requiredValueName')"
        ></el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('editAttrValue.display')" 
        prop="valueShow"
        :label-width="formLabelWidth"
      >
        <el-select 
          v-model="editAttrValueInfo.valueShow" 
          :placeholder="$t('editAttrValue.requiredDisplay')"
          style="width:100%"
        >
          <el-option 
            :label="$t('editAttrValue.yes')" 
            value="Y"
          ></el-option>
          <el-option 
            :label="$t('editAttrValue.no')" 
            value="N"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editAttrValue">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateAttrValue } from '@/api/dev/attrValueApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditAttrValue',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '120px',
      editAttrValueInfo: {
        specId: '',
        valueId: '',
        value: '',
        valueName: '',
        valueShow: '',
        shopId: ''
      },
      rules: {
        value: [
          { required: true, message: this.$t('editAttrValue.valueRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('editAttrValue.valueMaxLength'), trigger: 'blur' }
        ],
        valueName: [
          { required: true, message: this.$t('editAttrValue.valueNameRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('editAttrValue.valueNameMaxLength'), trigger: 'blur' }
        ],
        valueShow: [
          { required: true, message: this.$t('editAttrValue.displayRequired'), trigger: 'change' }
        ],
        valueId: [
          { required: true, message: this.$t('editAttrValue.valueIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.editAttrValueInfo = {
        ...params,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.editAttrValueForm.resetFields()
      this.editAttrValueInfo = {
        specId: '',
        valueId: '',
        value: '',
        valueName: '',
        valueShow: '',
        shopId: ''
      }
    },
    async editAttrValue() {
      this.$refs.editAttrValueForm.validate(async valid => {
        if (valid) {
          try {
            await updateAttrValue(this.editAttrValueInfo)
            this.$message.success(this.$t('editAttrValue.editSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('修改属性值失败:', error)
          }
        }
      })
    }
  }
}
</script>